import { render, staticRenderFns } from "./login.vue?vue&type=template&id=1a83af77&scoped=true"
import script from "./login.ts?vue&type=script&lang=js&external"
export * from "./login.ts?vue&type=script&lang=js&external"
import style0 from "./login.vue?vue&type=style&index=0&id=1a83af77&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a83af77",
  null
  
)

export default component.exports